import { useLocation } from "react-router-dom";
import { Link } from "@/components/LocaleLink";
import { useI18n } from "@/i18n/I18nProvider";

const NotFound = () => {
  const location = useLocation();
  const { m } = useI18n();

  // Only log in development mode
  if (import.meta.env.DEV) {
    console.error("404 Error:", location.pathname);
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <main className="flex-1 flex items-center justify-center">
        <div className="text-center px-6">
          <h1 className="font-display font-medium text-6xl text-primary mb-4">404</h1>
          <p className="font-mono text-xs uppercase tracking-[0.12em] text-muted-foreground mb-8">
            {m.common.notFound}
          </p>
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 font-mono text-sm text-primary hover:underline"
          >
            ← {m.common.returnHome}
          </Link>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
